import React from 'react';
import { GlobalAiRovoButtonWithBoundary } from '@jira/ai-rovo__button/src/GlobalAiRovoButtonWithBoundary.tsx';
import {
	GlobalBottomRightCornerContainer,
	BottomRightInlineItem,
} from '@atlassian/jira-layout-controller/src/ui/bottom-right-corner/container/index.tsx';
import { ConditionalHydrationBoundaryPlaceholder } from '@atlassian/jira-placeholder';
import { fg } from '@atlassian/jira-feature-gating';

export function JiraSpaGlobalBottomRightCorner(): JSX.Element {
	return (
		<ConditionalHydrationBoundaryPlaceholder
			name="global-right-bottom-corner-container"
			condition={fg('jfp-magma-add-corner-container-suspense')}
			fallback={null}
		>
			{fg('global_rovo_button_in_jira') ? (
				<GlobalBottomRightCornerContainer>
					<BottomRightInlineItem>
						<GlobalAiRovoButtonWithBoundary />
					</BottomRightInlineItem>
				</GlobalBottomRightCornerContainer>
			) : (
				<GlobalBottomRightCornerContainer />
			)}
		</ConditionalHydrationBoundaryPlaceholder>
	);
}
